//--------------------
// get toggle SR cols
//--------------------
export default function getToggleSRCols(headings) {
  // console.log("-----------------------");
  // console.log("IN getToggleSRCols");
  let colNumbers = []
  //--------------------------
  // set field cols to toggle
  //--------------------------
  let fields = [
    "image",
    "name", 
    "player_name",
    "category",
    "dex", 
    "fill4",
    "sr",
    "sr_adj",
    "sr_roll_image", 
    "roll_off_image",
    "rank",
  ];
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    let idx = headings.findIndex((a) => a.field == fields[k]);
    colNumbers.push(idx);
  }

  return colNumbers;
}
